/*eslint-disable @typescript-eslint/restrict-plus-operands */
import { FC, useContext, useEffect, useState } from "react";
import clsx from "clsx";
import { Button } from "@ht/components";
import VideoOnIcon from "@ht/shared/fonts/deos-pis/video-on";
import SadIcon from "@ht/shared/fonts/deos-pis/emoji-sad";
import CloseIcon from "@ht/shared/fonts/deos-pis/close";


import { IVCallIncomingMessage, IVCallState } from "../../../../app/videocall/types";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { vCallIncomingMessageReceived, vCallSendMessage, vCallStateChanged } from "../../../../app/videocall/videoSlice";
import { setFloatingCoordinate, setOverlay } from "../../../../app/layout/layoutStateSlice";
import { toIsoString, uid } from "@ht/shared/methods";
import { now } from "moment";
import { useDragging } from "../../../../hooks/useDragging";

import { ConferenceContext } from "../..";

import { setOnCall } from "../../../../app/userState/userStateSlice";
import ringtone from "../../../../../public/sound/ringtone.mp3";
import useSound from "use-sound";
import VideoCard from "../Cards/VideoCard";
import { useHttpRequest } from "../../../../hooks/useHttpRequest";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../../../../utils/encryption";

interface IProps {
    streamName: string;
    handleStreamName(name: string): void;
    handleChangeRoomStatus(status: string): void;
    meetingStatus: string
}

const MiniVideoCallControl: FC<IProps> = ({ handleChangeRoomStatus, handleStreamName, meetingStatus }) => {
    const conference = useContext(ConferenceContext);

    const dispatch = useAppDispatch();
    const { sendRequest } = useHttpRequest();
    const { user } = useAppSelector((state) => state.auth);
    const { incomingRoom } = useAppSelector((state) => state.chat);
    const { vCallState, vCallIncomingMessage } = useAppSelector((state) => state.vcall);
    const { floatingLocation, overlay } = useAppSelector((state) => state.layoutstate);
    const allowVideo = meetingStatus.includes("video")
    const [callConnected, setCallConnected] = useState(false);
    const [pickedUp, setPickedUp] = useState(false);
    const [ringing, setRinging] = useState(true);
    const [callTime] = useState(Date.now());
    const [callDescription, setCallDescription] = useState(`Incoming video call...`);
    const [callId, setCallId] = useState("")
    const [rejected] = useState(false)
    const [busyIntervalId, setBusyIntervalId] = useState(0)
    const callnotifWidth = 260;

    const locationX = floatingLocation.x === 0 ? (screen.width - callnotifWidth) / 2 : floatingLocation.x
    const locationY = floatingLocation.y === 0 ? floatingLocation.y + 99 : floatingLocation.y
    const [fullscreen] = useState(false);
    const { ref, x, y, isDragging, setPos } = useDragging(locationX, locationY, 260, 256);
    const [ready, setReady] = useState(false)
    const [play, { stop }] = useSound(ringtone);

    const leadsServiceUrl = process.env.REACT_APP_CAMPAIGN_SERVICE;
    const chatServiceUrl = process.env.REACT_APP_CHAT_SERVICE;
    const { sendRequest: sendReqLeads } = useHttpRequest(leadsServiceUrl);

    const notifyDialResult = (dialresult: string) => {

        const activecall = {
            CallId: callId
            , CalleeStreamId: "agentStream" + String(user?.deviceId)
            , CallerStreamId: vCallIncomingMessage.deviceid
            , Callee: user?.username
            , Caller: vCallIncomingMessage.username
            , DialResult: dialresult
            , CallTime: toIsoString(new Date(callTime))
            , DisconnectedTime: dialresult === "Ringing" || dialresult === "Answer" ? undefined : toIsoString(new Date())
            , Channel: "video"
            , SessionId: vCallIncomingMessage.sessionid
            , CallType: vCallIncomingMessage.calltype
        }
        const payload = {
            requesttype: "DialResult"
            , ActiveCall: activecall
        }
        dispatch(vCallSendMessage({
            content:
                JSON.stringify(payload)
        }));
    }
    const disableWeblink = () => {
        const payload = {
            requesttype: "UpdateWeblink"
            , weblinkId: vCallIncomingMessage.weblinkid
            , username: user?.username
        }
        dispatch(vCallSendMessage({
            content:
                JSON.stringify(payload)
        }));
    }
    const tempVTA = {
        videoLabel: "localVideo",
        track: null,
        streamId: "localVideo",
        isMine: true
    };
    const resetIncomingCall = () => {
        dispatch(vCallIncomingMessageReceived({} as IVCallIncomingMessage));
        dispatch(vCallStateChanged({} as IVCallState));

    }
    const [userStreamName, setUserStreamName] = useState("")
    const [customerId, setCustomerId] = useState("");
    const [customerName, setCustomerName] = useState("");

    const [weblinkSessionId, setWeblinkSessionId] = useState("")
    const [weblinkPhoneNumber, setWeblinkPhoneNumber] = useState("")

    const loadCustomerData = async () => {
        const customerid = await loadCustomerId()
        const custid = customerid.data as any
        setCustomerId(custid.customer_id)
        setWeblinkSessionId(custid.session_id)
        setWeblinkPhoneNumber(custid.username)
        console.log("data customer>", custid)
        const customer = await loadCustomerName(custid.customer_id)
        const name = customer.data as any
        setCustomerName(name);
        setUserStreamName(`${name.firstname}${name.lastname == null ? "" : ` ${name.lastname}`}`)

    }

    const loadCustomerId = async () => {
        const data = await sendRequest({
            baseUrl: chatServiceUrl,
            url: `/chat/get-weblink-custid/${vCallIncomingMessage.weblinkid}/${vCallIncomingMessage.tenantid}`,
            method: "get",
        });
        return data;
    }
    const loadCustomerName = async (customerid: string) => {
        console.log("data customer> encrypting:", customerid)
        const data = await sendReqLeads({
            url: `/customer/customer-data/${encrypt(customerid)}`,
            method: "get",

        });
        console.log("result", data)
        return data;
    }
    const navigate = useNavigate();
    const answerCall = async () => {
        if (!user)
            return;
        const baseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
        const leadsUrl = String(process.env.REACT_APP_LEADS_SERVICE);
        const interactionUrl = String(process.env.REACT_APP_INTERACTION_SERVICE);
        stop()
        handleStreamName(vCallIncomingMessage.streamId)
        clearInterval(busyIntervalId)
        setRinging(false);
        setPickedUp(true);
        setCallConnected(true);
        setCallDescription("Answered");
        notifyDialResult("Answer")
        let sessionid = incomingRoom.find(z => z.roomId == vCallIncomingMessage.roomId)?.sessionId
        if (sessionid === undefined || sessionid === "")
            sessionid = uid(36)
        const vcstate = { ...vCallState };
        vcstate.SessionId = String(sessionid)
        vcstate.roomId = vCallIncomingMessage.roomId
        vcstate.username = vCallIncomingMessage.username
        vcstate.name = vCallIncomingMessage.username
        vcstate.isCalling = true;
        vcstate.connectedTime = now()
        vcstate.CallId = callId
        vcstate.phoneNumber = weblinkPhoneNumber

        const payload = {
            deviceId: user.deviceId,
            userName: weblinkPhoneNumber,
            email: "",
            phoneNumber: weblinkPhoneNumber,
            fullName: vCallIncomingMessage.username,
            serviceGroupId: vCallIncomingMessage.servicegroupid,
            tag: "generic",
            agentUserName: user.username,
            agentDeviceId: user.deviceId,
            sessionId: weblinkSessionId,
            tenantId: user.tenantId,
            channel: "WHATSAPP",
            channelApplicationId: vCallIncomingMessage.channelapplicationid,
            customerId
        }
        setPos({
            x: x - 260,
            y: y,
        })
        conference.setIsJoining(true);
        conference.setStreamName(user?.fullname)
        conference.setRoomName(vCallIncomingMessage.weblinkid)
        const path = window.location.pathname;

        const BCAttribute = await sendRequest({
            baseUrl: leadsUrl,
            url: `/whatsapp-broadcast/getBroadcastAttribute/${customerId}`,
            method: "get",

        });
        const isBCOutbound = (BCAttribute as any).data?.type == "outbound"
        const isBCInbound = (BCAttribute as any).data?.type == "inbound"
        let assignmentId=0
        if (isBCOutbound) {
            const assignSuccess = await sendRequest({
                baseUrl: leadsUrl,
                url: `/whatsapp-broadcast/assign`,
                method: "post",
                body: payload,

            }) as any;
            // if (!path.includes("leads")) { navigate(`/leads`) }
            // setTimeout(() => {
            //     navigate(`/leads/${encrypt(customerId)}`)
            // }, 1000);

            vcstate.campaignId = assignSuccess.data.campaignId
            vcstate.customerId = customerId;
            vcstate.roomId = assignSuccess.data.assignmentId;
            vcstate.isOutboundRoom=true;
            assignmentId=assignSuccess.data.assignmentId;
            disableWeblink()

        } else if (isBCInbound) {
            await sendRequest({
                baseUrl: baseUrl,
                url: `/chat/JoinRoomAll`,
                method: "post",
                body: payload,

            });
            // if (!path.includes("messages")) { navigate(`/messages`) }
            vcstate.customerId = customerId
            vcstate.roomId = weblinkPhoneNumber
        } else
            vcstate.customerId = customerId
            vcstate.roomId=weblinkPhoneNumber

        dispatch(vCallStateChanged(vcstate));
        
        
        setTimeout(async() => {
            const payloadInteractionDetail={
    
                caller: customerId,
                callee: user.userId,
                wlSessionId: isBCOutbound?assignmentId:weblinkSessionId,
                sessionId: vCallIncomingMessage.sessionid,
                weblinkId: vCallIncomingMessage.weblinkid
            }
            console.log("payload interaction detail", payloadInteractionDetail)
            await sendRequest({
                baseUrl: interactionUrl,
                url: `/interaction/save-video-interaction-detail`,
                method: "post",
                body: {
    
                    caller: customerId,
                    callee: user.userId,
                    wlSessionId: isBCOutbound?assignmentId:weblinkSessionId,
                    sessionId: vCallIncomingMessage.sessionid,
                    weblinkId: vCallIncomingMessage.weblinkid
                }
    
            });
        }, 3000);


    }
    useEffect(() => {
        if (conference.streamName != "") {
            const streamId = vCallIncomingMessage.streamId;
            conference.joinRoom(conference.roomName, streamId, "mcu");//idris uncomment pls

            setTimeout(() => {
                handleChangeRoomStatus("meeting-video-dms");
            }, 1000);

        }
    }, [conference.streamName])



    const Busy = () => {
        stop()
        setRinging(false);
        setPickedUp(false);
        setCallDescription("Missed Call. You were busy.")
        notifyDialResult("Busy");
        dispatch(setOnCall(""));
        resetIncomingCall();

    }
    const BusyTimer = () => {
        let i = 0;
        let sentRinging = false;
        const tmr = window.setInterval(() => {
            if (callId !== "" && !sentRinging) {
                notifyDialResult("Ringing")
                sentRinging = true
            }
            i++;
            if (i > 20) {
                if (!callConnected && !rejected) {

                    Busy()
                    handleChangeRoomStatus("missing-video-dms")
                }
                window.clearInterval(tmr)
            }
        }, 1000);
        setBusyIntervalId(tmr)
    }

    const closeModal = () => {
        conference.turnOffLocalCamera("localVideo");
        window.clearInterval(busyIntervalId)
        handleChangeRoomStatus("close")
        dispatch(setOnCall(""))
        resetIncomingCall();

    }

    useEffect(() => {
        if (meetingStatus === "waiting-video-dms") {
            setPickedUp(false)
            setRinging(true);
            //BusyTimer()
            setCallDescription("Incoming video call...")
            loadCustomerData().catch(() => { })
        }

    }, [meetingStatus])


    const callButton = (<>

        <div className="flex flex-row justify-center h-[68px] w-[100%] justify-center gap-[36px]">

            <div className="flex flex-col items-center gap-[8px]">
                <Button shape="ellipse" onClick={() => answerCall()} type="button" variant="contained" color="primary" iconButton className="w-[44px] h-[44px]">
                    <VideoOnIcon className="w-6 h-6 text-white" />

                </Button>
                <span className="text-white text-base font-semibold">Accept</span>
            </div>
        </div>
    </>)

    const startCamera = () => {
        if (!conference.isPlayOnly && conference.initialized) {
            conference?.checkAndTurnOnLocalCamera("localVideo");
            const tempLocalVideo = document.getElementById("localVideo");
            conference?.localVideoCreate(tempLocalVideo);
            

        }
    }
    useEffect(() => {
        if (conference.initialized && meetingStatus.includes("waiting"))
            startCamera()
    }, [conference.initialized, meetingStatus]);


    useEffect(() => {
        play()
        setCallId(uid(21))
        setReady(true)
        return () => {
            stop()
        }
    }, [])
    useEffect(() => {
        if (ready)
            if (!isDragging)
                dispatch(setFloatingCoordinate({ x, y }));
    }, [isDragging])



    return (
        <>
            <div onClick={() => dispatch(setOverlay(false))} onKeyDown={() => { }} role="none" className={clsx("fixed z-[19] w-screen h-screen flex justify-center items-center bg-gray-900 opacity-[0.2] duration-700",
                !overlay && "hidden"
            )}>
            </div>
            <div

                style={{
                    left: x,
                    top: y,
                }}
                className={clsx(
                    isDragging && "bg-geyser",
                    !isDragging && "bg-white",
                    pickedUp && !fullscreen && "w-[520px]",
                    !pickedUp && !fullscreen && "w-[260px]",
                    fullscreen && "w-[100%]",

                    `absolute shadow-sm rounded-lg bg-white z-[21] absolute overflow-hidden`
                )}>

                <div className="flex flex-col justify-between h-[200px] items-center overflow-hidden">
                    <VideoCard trackAssignment={tempVTA} name="videolocal" id="localVideo" autoPlay muted hidePin={true} onHandlePin={() => { }} />
                    <div className={
                        clsx("w-[100%] h-[100%] rounded-lg p-[10px] absolute top-[0px]",
                            !pickedUp && " bg-black/[.30]"
                        )}
                    >

                        <div ref={ref} className="draggable flex flex-col-reverse justify-between h-[100%] items-center justify-between gap-[8px]">

                            <div className="h-[68px]">
                                {(ringing || pickedUp) && callButton}
                                {(!ringing && !pickedUp) &&
                                    (
                                        <div className="flex flex-row justify-center h-[68px] w-[100%] justify-center gap-[36px] -mt-[20px]">
                                            <Button shape="ellipse" onClick={() => { }} type="button" variant="contained" color="danger" iconButton className="w-[44px] h-[44px]">
                                                <SadIcon className="w-6 h-6 text-white" />
                                            </Button>
                                        </div>
                                    )
                                }

                            </div>
                            {
                                !pickedUp ? (<>
                                    <div className="flex flex-col items-center justify-between pb-[20px]">
                                        <div className="text-lg font-semibold text-white">
                                            {userStreamName??weblinkPhoneNumber}

                                        </div>
                                        <div className="text-base font-normal text-white">{callDescription}</div>

                                    </div>

                                </>) : <></>
                            }
                            <div className="flex flex-row justify-between w-[100%]">
                                <div className="text-md text-white self-end z-[1000] p-[2px] rounded-lg text-black"></div>
                                {!pickedUp ? (<>
                                    <div role="button" tabIndex={-1}
                                        onKeyDown={
                                            closeModal
                                        }
                                        onClick={
                                            closeModal
                                        } className="text-md text-white self-end"><CloseIcon className="w-[16px] h-[16px]" width={24} height={24} />
                                    </div>
                                </>) : <></>}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MiniVideoCallControl;
